import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';
import { Observable } from 'rxjs';
import { HttpService } from '../../services/http.service';
import { environment } from 'src/environment/environment';
import { CookieService } from 'ngx-cookie-service';
import { AuditService } from 'src/app/core/services/audit.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public onLogin: EventEmitter<boolean> = new EventEmitter();
  private endpoint:string = environment.api_gw + 'auth/auth';
  
  constructor(
    private router:Router,
    private storage: LocalStorageService,
    private sessionStorage: SessionStorageService,
    private http:HttpClient,
    private HttpService: HttpService,
    private cookieService: CookieService,
    private auditService: AuditService
  ) {

  }

  login(username:string, password:string):Observable<any>{
    let payload = {
      Username: username,
      Password: password
    };
    
    let observable = new Observable((observer) => {
      this.http.post(this.endpoint + '/login', payload).subscribe({
        next: (data:any) => {

          this.storage.set("token", data.accessToken);
          this.storage.set("user", data.user);
          this.storage.set("permissions", data.permissions);

          if(environment.cookie_domain !== null && environment.cookie_domain !== '') {
            this.cookieService.set("Authorization", data.accessToken, 0, "/", environment.cookie_domain, false, "None");
          } else {
            this.cookieService.set("Authorization", data.accessToken);
          }

          //nueva sesión de auditoría, para poder agrupar la actividad por sesión
          this.auditService.startSession();

          this.onLogin.emit(true);

          observer.next(data);

        },
        error: (error)=>{
          observer.error(error);
        }
      });
    });
    
    return observable;

  }

  logout(){
    //enviamos la actividad pendiente mientras el token sigue siendo válido
    this.auditService.flush();

    let user = this.storage.get('user');
    if(user){
      let userId = user.id;
      this.http.get(this.endpoint + '/logout/' + userId).subscribe({
        next: (data:any) => {
        },
        error: (err:any) => {
          console.warn("Cierre de sesión no registrado", err);
        },
        complete: () => {
          //quitar token
          this.storage.remove('token');
          this.storage.remove('user');
          this.storage.remove('permissions');
          this.sessionStorage.clear();
          this.onLogin.emit(false);
          if(location.pathname!='/login' && !location.pathname.startsWith('/public')) location.replace('/login');
        }
      });
    }else{
      //quitar token
      this.storage.remove('token');
      this.storage.remove('user');
      this.storage.remove('permissions');
      this.sessionStorage.clear();
      this.onLogin.emit(false);
      if(location.pathname!='/login' && !location.pathname.startsWith('/public')) location.replace('/login');
    }
  }


  checkSavedToken(): void {
    //obtener token
    let token = this.storage.get('token');

    //TODO: verificar si es valido el token o ha expirado
    if(token!=null){
      //si esta logado y no esta accediendo a login
      if(!location.pathname.startsWith('/login') && !location.pathname.startsWith('/public')){
        //el aviso sale en el siguiente turno, no medio segundo después.
        //
        //Con 500 ms, el topbar y la barra lateral —que cuelgan de `is_user_logged` en app.component— tardaban ese
        //tiempo en aparecer, y al aparecer empujaban hacia abajo el contenido ya pintado. Cualquier pantalla que
        //mida su propia posición al iniciarse (el buzón) se quedaba con la medida de antes y se salía por abajo.
        //
        //Sigue siendo asíncrono a propósito, para no emitir en medio de la construcción del componente raíz. Y se
        //ha comprobado que los tres suscriptores de `onLogin` (app.component, phone.service y topbar) se registran
        //antes de que esto se ejecute, así que adelantarlo no hace que ninguno se pierda el aviso.
        setTimeout(()=>{
          if(environment.cookie_domain !== null && environment.cookie_domain !== '') {
            this.cookieService.set("Authorization", token, 0, "/", environment.cookie_domain, false, "None");
          } else {
            this.cookieService.set("Authorization", token);
          }
          this.onLogin.emit(true);
        }, 0);

        //si esta entrando a /, redirigir a home
        if(location.pathname=='/'){
          this.router.navigate(['/home']);
        }
      }else{
        //si está entrando a login, borramos sesion anterior
        this.logout();
      }
    }else{
      //reenviamos al login, salvo que ya este alli
      if(!location.pathname.startsWith('/login') && !location.pathname.startsWith('/public')){
        this.router.navigate(['/login']);
      }
    }
  }

  hasAnyPermission(permissions: string[]):boolean {
    const value = this.storage.get("permissions");
    if (value !== null) {
      for (const permission of permissions) {
        const aux = value.indexOf(permission)
        if (aux !== -1) {
          return true;
        }
      }
    }
    return false;
  }

  hasPermission(permission: string):boolean {
    const value = this.storage.get("permissions");
    if (value !== null) {
      const aux = value.indexOf(permission)
      if (aux !== -1) {
        return true;
      }
    }
    return false;
  }

  resetPassword(email:string): Observable<any> {
    let payload = {
      username: email,
      password:""
    };
    return this.http.post<object>(this.endpoint + "/reset_password", payload);
  }

}
